import { AxiosResponse } from 'axios';
import { useMemo } from 'react';

import { useLogout } from 'hooks/useLogout';

export const useResponse401Interceptor = () => {
  const { logoutForgerock } = useLogout();

  const response401Interceptor = useMemo(
    () => [
      // onFulfilled
      (response: AxiosResponse) => {
        return response;
      },
      // onRejected
      // Has to be `any` type as this is the type Axios expects, and it does not accept generic types for the error type
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (error: any) => {
        if (error?.response?.status === 401) {
          logoutForgerock();
        }
        return Promise.reject(error);
      },
    ],
    [logoutForgerock],
  );

  return { response401Interceptor };
};
